module.exports = __webpack_public_path__ + "img/steam-turbine-V-shadow.ace6391b.png";